/* components.js
--------------------------------------------------------------------------------

COMPONENTS [ TABLE OF CONTENTS ]


VARIABLES
--------------------------------------------------------------------------------
Main Variables


DATAGRID
--------------------------------------------------------------------------------
1.1   Row actions links
1.2   Sticky table heades
1.3   Sort table rows

FORMS
--------------------------------------------------------------------------------
2.1		Bootstrap Form Validation
2.2		Chosen Plugin
2.3		DateTime Picker

MODALS
--------------------------------------------------------------------------------
3.1		Modal Saving Spinner
3.2		Modal Loading Spinner

ALERTS
--------------------------------------------------------------------------------
4.1		SweetAlert2

CHARTS
--------------------------------------------------------------------------------
5.1		Chartist

MISC
--------------------------------------------------------------------------------
9.1		Bootstrap Popover

INIT FUNCTIONS
--------------------------------------------------------------------------------
A.1   Window Load Function
A.2   Document Ready Function
A.3   Window Resize Function

--------------------------------------------------------------------------------
*/


(function($) {
	"use strict";

  // VARIABLES
  // ---------------------------------------------------------------------------


  // DATAGRID
  // ---------------------------------------------------------------------------
  // 1.1  Row Actions Links
  function init_rowActionsLinks() {
    // Open normal link
    $(".row-link td:not(.row-actions)").click(function() {
        window.document.location = $(this).parent().data("href");
    });
    // Open modals link
    $(".row-modal-link td:not(.row-actions)").click(function() {
      $($(this).parent().data("href")).modal('show')
    });
  }

  // 1.2  Sticky table headers
  function init_stickyTableHeaders() {
    $('.table-sticky').stickyTableHeaders({scrollableArea: $('.page-body')});
  }

  // 1.3  Sort table rows
  function init_sortTableRows() {
    $('a.sortable').click(function() {
      if ($(this).hasClass('sort-asc')){
        $(this).removeClass('sort-asc').addClass('sort-desc');
      } else if ($(this).hasClass('sort-desc')){
        $(this).removeClass('sort-desc');
      } else {
        $(this).addClass('sort-asc');
      }
    });
  }


	// FORMS
  // ---------------------------------------------------------------------------
	// 2.1	Bootstrap Form Validation
	window.addEventListener('load', function() {
		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		var forms = document.getElementsByClassName('needs-validation');
		// Loop over them and prevent submission
		var validation = Array.prototype.filter.call(forms, function(form) {
			form.addEventListener('submit', function(event) {
				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add('was-validated');
			}, false);
		});
	}, false);

	// 2.2	Chosen Plugin
	function init_chosenPlugin() {
		$(".form-control-chosen").chosen(); // Default Chosen

		$(".form-control-chosen-simple").chosen({
			disable_search: true
		}); // Simple

		$(".my_select_box").chosen({
		 disable_search_threshold: 10,
		 no_results_text: "Oops, nothing found!",
		 width: "95%"
	 });
	}

	// 2.3	DateTime Picker
	function init_dateTimePicker() {
		$(".datetimepicker").flatpickr(
			{
    		enableTime: true,
    		dateFormat: "Y-m-d H:i",
			}
		);
	}

	// MODALS
  // ---------------------------------------------------------------------------
	// 3.1	Modal Saving Spinner
	function init_modalSavingSpinner() {
		let modalContainer = 	$('.modal');

		$.each(modalContainer, function(){

			if($(this).find('.modal-footer .btn-save').hasClass('btn-spinner')){

				let btnLabel = $(this).find('.modal-footer .btn.btn-save span').html();
				let spinnerButton = $(this).find('.modal-footer .btn-spinner');

				$(this).find('.modal-footer .btn').click(function() {
					if ($(this).hasClass('btn-cancel')){
						spinnerButton.removeClass('active');
						spinnerButton.find('span').html(btnLabel);
					}

					if ($(this).hasClass('btn-spinner')){
						spinnerButton.addClass('active');
						spinnerButton.find('span').queue(function(n) {
							$(this).html('Saving...');
							n();
						}).delay(2000).queue(function(n) {
							$(this).html(btnLabel);
							spinnerButton.removeClass('active');
							n();
						});

					}
				});
			}
		});
	}

	// 3.2	Modal Loading Spinner
	function init_modalLoadingSpinner() {
		let modalContainer = 	$('.modal');

		$.each(modalContainer, function(){

			if($(this).hasClass('modal-spinner')){

				$(this).on('shown.bs.modal', function () {
  				$(this).find('.modal-spinner-container').delay(4000).fadeOut();
				});
				$(this).on('hidden.bs.modal', function () {
  				$(this).find('.modal-spinner-container').show();
				});
			}
		});
	}

	// ALERTS
	// ---------------------------------------------------------------------------
	// 4.1	SweetAlert2
	function init_sweetAlerts() {

		$(".swa-delete").click(function() {
			Swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.value) {
					Swal.fire(
						'Deleted!',
						'Your file has been deleted.',
						'success'
					)
				}
			});
		});


	}

	// CHARTS
	// ---------------------------------------------------------------------------
	// 5.1	Chartist
	function init_chartist() {
		new Chartist.Line('.d-week-chart', {
		  labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
		  series: [
		    [102, 133, 92, 83, 123, 195, 110]
		  ]
		}, {
		  low: 0,
		  showArea: true,
			fullWidth: true,
			fullHeight: true,
			chartPadding: {
		    right: 40,
		    left: 5,
		  },
			plugins: [
		    Chartist.plugins.tooltip({
		      appendToBody: true
		    })
		  ]
		});
		new Chartist.Line('.d-month-chart', {
		  labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
		  series: [
		    [92, 139, 198, 182, 150, 178, 164, 132, 176, 105, 145, 123, 139, 171, 187, 143, 120, 98, 35, 63, 78, 134, 189, 148, 123, 143, 129, 122, 156, 187, 134]
		  ]
		}, {
		  low: 0,
		  showArea: true,
			fullWidth: true,
			fullHeight: true,
			chartPadding: {
				right: 40,
				left: 5,
			},
			plugins: [
		    Chartist.plugins.tooltip({
		      appendToBody: true
		    })
		  ]
		});
	}


	// MISC
  // ---------------------------------------------------------------------------
	// 9.1	Bootstrap Popover
	function init_bsPopOver() {
		$('[data-toggle="popover"]').popover();
		$('[data-toggle="tooltip"]').tooltip();
	}

  // INIT FUNCTIONS

  // ---------------------------------------------------------------------------
  // A.1  WINDOW LOAD FUNCTIONS

	$(window).on('load', function() {

	});


  // ---------------------------------------------------------------------------
	// A.2 DOCUMENT READY FUNCTIONS

	jQuery(document).ready(function($) {

    init_rowActionsLinks();             // 1.1  Row Actions Links
    init_stickyTableHeaders();          // 1.2  Sticky table headers
    init_sortTableRows();               // 1.3  Sort table rows

		init_chosenPlugin();								// 2.2	Chosen Plugin
		init_dateTimePicker();						  // 2.3	DateTime Picker

		init_modalSavingSpinner();					// 3.1	Modal Saving Spinner
		init_modalLoadingSpinner();					// 3.1	Modal Loading Spinner

		init_sweetAlerts();									// 4.1	SweetAlert2

		if($('.page-dashboard').length){
			init_chartist();									// 5.1	Chartist
		}

		init_bsPopOver();										// 9.1	Bootstrap Popover


	});


  // ---------------------------------------------------------------------------
	// A.3 WINDOW RESIZE FUNCTIONS

	$(window).on('resize', function () {

    init_stickyTableHeaders();          // 1.2  Sticky table headers

	});

})(jQuery);
